// Pages
import {
  ResumenGeneral as ResumenGeneral_2020,
  EvacuadosPorProvincia as EvacuadosPorProvincia_2020,
  DatosDemograficos as DatosDemograficos_2020,
} from "./pages/2020";

import {
  SanJose as SanJose_2020,
  Alajuela as Alajuela_2020,
  Heredia as Heredia_2020,
  Cartago as Cartago_2020,
  Puntarenas as Puntarenas_2020,
  Guanacaste as Guanacaste_2020,
  Limon as Limon_2020,
} from "./pages/2020/EvacuadosPorCanton";

import {
  ResumenGeneral as ResumenGeneral_2021,
  EvacuadosPorProvincia as EvacuadosPorProvincia_2021,
  DatosDemograficos as DatosDemograficos_2021,
} from "./pages/2021";

import {
  SanJose as SanJose_2021,
  Alajuela as Alajuela_2021,
  Heredia as Heredia_2021,
  Cartago as Cartago_2021,
  Puntarenas as Puntarenas_2021,
  Guanacaste as Guanacaste_2021,
  Limon as Limon_2021,
} from "./pages/2021/EvacuadosPorCanton";

import {
  SanJose as SanJose_2023,
  Alajuela as Alajuela_2023,
  Heredia as Heredia_2023,
  Cartago as Cartago_2023,
  Puntarenas as Puntarenas_2023,
  Guanacaste as Guanacaste_2023,
  Limon as Limon_2023,
} from "./pages/2023/EvacuadosPorCanton";

import {
  ResumenGeneral as ResumenGeneral_2023,
  EvacuadosPorProvincia as EvacuadosPorProvincia_2023,
  DatosDemograficos as DatosDemograficos_2023,
  EvacuadosPorSector as EvacuadosPorSector_2023
} from "./pages/2023";

import {
  SanJose as SanJose_2024,
  Alajuela as Alajuela_2024,
  Heredia as Heredia_2024,
  Cartago as Cartago_2024,
  Puntarenas as Puntarenas_2024,
  Guanacaste as Guanacaste_2024,
  Limon as Limon_2024,
} from "./pages/2024/EvacuadosPorCanton";

import {
  SanJose as SanJose_2025,
  Alajuela as Alajuela_2025,
  Heredia as Heredia_2025,
  Cartago as Cartago_2025,
  Puntarenas as Puntarenas_2025,
  Guanacaste as Guanacaste_2025,
  Limon as Limon_2025,
} from "./pages/2025/EvacuadosPorCanton";

import {
  ResumenGeneral as ResumenGeneral_2024,
  EvacuadosPorProvincia as EvacuadosPorProvincia_2024,
  DatosDemograficos as DatosDemograficos_2024,
  EvacuadosPorSector as EvacuadosPorSector_2024
} from "./pages/2024";

import {
  ResumenGeneral as ResumenGeneral_2025,
  EvacuadosPorProvincia as EvacuadosPorProvincia_2025,
  DatosDemograficos as DatosDemograficos_2025,
  EvacuadosPorSector as EvacuadosPorSector_2025
} from "./pages/2025";

import {
  SanJose as SanJose_2026,
  Alajuela as Alajuela_2026,
  Heredia as Heredia_2026,
  Cartago as Cartago_2026,
  Puntarenas as Puntarenas_2026,
  Guanacaste as Guanacaste_2026,
  Limon as Limon_2026,
} from "./pages/2026/EvacuadosPorCanton";

import {
  ResumenGeneral as ResumenGeneral_2026,
  EvacuadosPorProvincia as EvacuadosPorProvincia_2026,
  DatosDemograficos as DatosDemograficos_2026,
  EvacuadosPorSector as EvacuadosPorSector_2026
} from "./pages/2026";


import { ReactComponent as GeneralIcon } from "./img/icons/general.svg";
import { ReactComponent as ProvinciaIcon } from "./img/icons/provincia.svg";
import { ReactComponent as CantonIcon } from "./img/icons/canton.svg";
import { ReactComponent as DemograficosIcon } from "./img/icons/demograficos.svg";
import { ReactComponent as ReportesSismos } from "./img/icons/reportes_sismos.svg";
import { ReactComponent as SectoresIcon } from "./img/icons/Sectores.svg";

export default {
  items: [
        {
      path: "/2026",
      name: "Reportes 2026",
      type: "submenu",
      icon: GeneralIcon,
      children: [
        {
          path: "/",
          name: "Resumen general",
          type: "link",
          icon: GeneralIcon,
          component: ResumenGeneral_2026,
        },
        {
          path: "/evacuados-por-sector",
          name: "Evacuados por sector",
          type: "link",
          icon: SectoresIcon,
          component: EvacuadosPorSector_2026,
        },
        {
          path: "/evacuados-por-provincia",
          name: "Evacuados por provincia",
          type: "link",
          icon: ProvinciaIcon,
          component: EvacuadosPorProvincia_2026,
        },
        {
          path: "/evacuados-por-canton",
          name: "Evacuados por cantón",
          type: "submenu",
          icon: CantonIcon,
          children: [
            {
              path: "/san-jose",
              name: "San José",
              component: SanJose_2026,
            },
            {
              path: "/alajuela",
              name: "Alajuela",
              component: Alajuela_2026,
            },
            {
              path: "/cartago",
              name: "Cartago",
              component: Cartago_2026,
            },
            {
              path: "/heredia",
              name: "Heredia",
              component: Heredia_2026,
            },
            {
              path: "/guanacaste",
              name: "Guanacaste",
              component: Guanacaste_2026,
            },
            {
              path: "/puntarenas",
              name: "Puntarenas",
              component: Puntarenas_2026,
            },
            {
              path: "/limon",
              name: "Limón",
              component: Limon_2026,
            },
          ],
        },
        {
          path: "/datos-demograficos",
          name: "Datos demográficos",
          type: "link",
          icon: DemograficosIcon,
          component: DatosDemograficos_2026,
        },
        {
          path: "https://cnesimulacro-sim2026.web.app/#/home/qo7NLmWgX6xu1sDwGn9A/clusters",
          name: "Mapa de reportes",
          type: "external",
          icon: ReportesSismos,
        },
      ],
    },
    {
      path: "/2025",
      name: "Reportes 2025",
      type: "submenu",
      icon: GeneralIcon,
      children: [
        {
          path: "/",
          name: "Resumen general",
          type: "link",
          icon: GeneralIcon,
          component: ResumenGeneral_2025,
        },
        {
          path: "/evacuados-por-sector",
          name: "Evacuados por sector",
          type: "link",
          icon: SectoresIcon,
          component: EvacuadosPorSector_2025,
        },
        {
          path: "/evacuados-por-provincia",
          name: "Evacuados por provincia",
          type: "link",
          icon: ProvinciaIcon,
          component: EvacuadosPorProvincia_2025,
        },
        {
          path: "/evacuados-por-canton",
          name: "Evacuados por cantón",
          type: "submenu",
          icon: CantonIcon,
          children: [
            {
              path: "/san-jose",
              name: "San José",
              component: SanJose_2025,
            },
            {
              path: "/alajuela",
              name: "Alajuela",
              component: Alajuela_2025,
            },
            {
              path: "/cartago",
              name: "Cartago",
              component: Cartago_2025,
            },
            {
              path: "/heredia",
              name: "Heredia",
              component: Heredia_2025,
            },
            {
              path: "/guanacaste",
              name: "Guanacaste",
              component: Guanacaste_2025,
            },
            {
              path: "/puntarenas",
              name: "Puntarenas",
              component: Puntarenas_2025,
            },
            {
              path: "/limon",
              name: "Limón",
              component: Limon_2025,
            },
          ],
        },
        {
          path: "/datos-demograficos",
          name: "Datos demográficos",
          type: "link",
          icon: DemograficosIcon,
          component: DatosDemograficos_2025,
        },
        {
          path: "https://cnesimulacro-sim2025.web.app/#/home/zVtJsFOtg5pZ7FnWlAAi/clusters",
          name: "Mapa de reportes",
          type: "external",
          icon: ReportesSismos,
        },
      ],
    },
    {
      path: "/2024",
      name: "Reportes 2024",
      type: "submenu",
      icon: GeneralIcon,
      children: [
        {
          path: "/",
          name: "Resumen general",
          type: "link",
          icon: GeneralIcon,
          component: ResumenGeneral_2024,
        },
        {
          path: "/evacuados-por-sector",
          name: "Evacuados por sector",
          type: "link",
          icon: SectoresIcon,
          component: EvacuadosPorSector_2024,
        },
        {
          path: "/evacuados-por-provincia",
          name: "Evacuados por provincia",
          type: "link",
          icon: ProvinciaIcon,
          component: EvacuadosPorProvincia_2024,
        },
        {
          path: "/evacuados-por-canton",
          name: "Evacuados por cantón",
          type: "submenu",
          icon: CantonIcon,
          children: [
            {
              path: "/san-jose",
              name: "San José",
              component: SanJose_2024,
            },
            {
              path: "/alajuela",
              name: "Alajuela",
              component: Alajuela_2024,
            },
            {
              path: "/cartago",
              name: "Cartago",
              component: Cartago_2024,
            },
            {
              path: "/heredia",
              name: "Heredia",
              component: Heredia_2024,
            },
            {
              path: "/guanacaste",
              name: "Guanacaste",
              component: Guanacaste_2024,
            },
            {
              path: "/puntarenas",
              name: "Puntarenas",
              component: Puntarenas_2024,
            },
            {
              path: "/limon",
              name: "Limón",
              component: Limon_2024,
            },
          ],
        },
        {
          path: "/datos-demograficos",
          name: "Datos demográficos",
          type: "link",
          icon: DemograficosIcon,
          component: DatosDemograficos_2024,
        },
        {
          path: "https://cnesimulacro-sim2024.web.app/#/home/qgLiu0OW7NO0a3S6J60G/clusters",
          name: "Mapa de reportes",
          type: "external",
          icon: ReportesSismos,
        },
      ],
    },
    {
      path: "/2023",
      name: "Reportes 2023",
      type: "submenu",
      icon: GeneralIcon,
      children: [
        {
          path: "/",
          name: "Resumen general",
          type: "link",
          icon: GeneralIcon,
          component: ResumenGeneral_2023,
        },
        {
          path: "/evacuados-por-sector",
          name: "Evacuados por sector",
          type: "link",
          icon: SectoresIcon,
          component: EvacuadosPorSector_2023,
        },
        {
          path: "/evacuados-por-provincia",
          name: "Evacuados por provincia",
          type: "link",
          icon: ProvinciaIcon,
          component: EvacuadosPorProvincia_2023,
        },
        {
          path: "/evacuados-por-canton",
          name: "Evacuados por cantón",
          type: "submenu",
          icon: CantonIcon,
          children: [
            {
              path: "/san-jose",
              name: "San José",
              component: SanJose_2023,
            },
            {
              path: "/alajuela",
              name: "Alajuela",
              component: Alajuela_2023,
            },
            {
              path: "/cartago",
              name: "Cartago",
              component: Cartago_2023,
            },
            {
              path: "/heredia",
              name: "Heredia",
              component: Heredia_2023,
            },
            {
              path: "/guanacaste",
              name: "Guanacaste",
              component: Guanacaste_2023,
            },
            {
              path: "/puntarenas",
              name: "Puntarenas",
              component: Puntarenas_2023,
            },
            {
              path: "/limon",
              name: "Limón",
              component: Limon_2023,
            },
          ],
        },
        {
          path: "/datos-demograficos",
          name: "Datos demográficos",
          type: "link",
          icon: DemograficosIcon,
          component: DatosDemograficos_2023,
        },
        {
          path: "https://cnesimulacro-sim2023.web.app/#/home/qgLiu0OW7NO0a3S6J60G/clusters",
          name: "Mapa de reportes",
          type: "external",
          icon: ReportesSismos,
        },
      ],
    },
    {
      path: "/2021",
      name: "Reportes 2021",
      type: "submenu",
      icon: GeneralIcon,
      children: [
        {
          path: "/",
          name: "Resumen general",
          type: "link",
          icon: GeneralIcon,
          component: ResumenGeneral_2021,
        },
        {
          path: "/evacuados-por-provincia",
          name: "Evacuados por provincia",
          type: "link",
          icon: ProvinciaIcon,
          component: EvacuadosPorProvincia_2021,
        },
        {
          path: "/evacuados-por-canton",
          name: "Evacuados por cantón",
          type: "submenu",
          icon: CantonIcon,
          children: [
            {
              path: "/san-jose",
              name: "San José",
              component: SanJose_2021,
            },
            {
              path: "/alajuela",
              name: "Alajuela",
              component: Alajuela_2021,
            },
            {
              path: "/cartago",
              name: "Cartago",
              component: Cartago_2021,
            },
            {
              path: "/heredia",
              name: "Heredia",
              component: Heredia_2021,
            },
            {
              path: "/guanacaste",
              name: "Guanacaste",
              component: Guanacaste_2021,
            },
            {
              path: "/puntarenas",
              name: "Puntarenas",
              component: Puntarenas_2021,
            },
            {
              path: "/limon",
              name: "Limón",
              component: Limon_2021,
            },
          ],
        },
        {
          path: "/datos-demograficos",
          name: "Datos demográficos",
          type: "link",
          icon: DemograficosIcon,
          component: DatosDemograficos_2021,
        },
        {
          path: "https://cnesimulacro-visualizador-dark.web.app/#/home/AJiuGx95brKhPlz53xk1/clusters",
          name: "Mapa de reportes",
          type: "external",
          icon: ReportesSismos,
        },
      ],
    },
    {
      path: "/2020",
      name: "Reportes 2020",
      type: "submenu",
      icon: GeneralIcon,
      children: [
        {
          path: "/",
          name: "Resumen general",
          type: "link",
          icon: GeneralIcon,
          component: ResumenGeneral_2020,
        },
        {
          path: "/evacuados-por-provincia",
          name: "Evacuados por provincia",
          type: "link",
          icon: ProvinciaIcon,
          component: EvacuadosPorProvincia_2020,
        },
        {
          path: "/evacuados-por-canton",
          name: "Evacuados por cantón",
          type: "submenu",
          icon: CantonIcon,
          children: [
            {
              path: "/san-jose",
              name: "San José",
              component: SanJose_2020,
            },
            {
              path: "/alajuela",
              name: "Alajuela",
              component: Alajuela_2020,
            },
            {
              path: "/cartago",
              name: "Cartago",
              component: Cartago_2020,
            },
            {
              path: "/heredia",
              name: "Heredia",
              component: Heredia_2020,
            },
            {
              path: "/guanacaste",
              name: "Guanacaste",
              component: Guanacaste_2020,
            },
            {
              path: "/puntarenas",
              name: "Puntarenas",
              component: Puntarenas_2020,
            },
            {
              path: "/limon",
              name: "Limón",
              component: Limon_2020,
            },
          ],
        },
        {
          path: "/datos-demograficos",
          name: "Datos demográficos",
          type: "link",
          icon: DemograficosIcon,
          component: DatosDemograficos_2020,
        },
        {
          path: "https://cnesimulacro-visualizador.web.app/#/home/aXY3IUXGOR8Jt9wYvgHY/clusters",
          name: "Mapa de reportes",
          type: "external",
          icon: ReportesSismos,
        },
      ],
    }
  ],
};
